export const BASEURL = "https://turftown.in"; //https://turftown.in/
export const WHATSAPP_CHAT_URL = "https://wa.me/916379135581";

export const URLS = {
  GAME_INFO: "/game-info",
  PAYMENT_CHECK: "/payment-check",
  PAYMENT_CHECK_NEW: "/payment-status",
  GAME_CART: "/game-cart",
  GAME_DETAILS: "/game",
  GAMES: "/games",
  ALL_GAMES: "/all-games",
  VENUE_CART: "/time-slots",
  VENUE_BOOK: "/venue-cart",
};
